import { batch, useDispatch, useSelector } from 'react-redux';
import React, { useCallback } from 'react';

import styles from '../Components.module.css';

import {
  setNeedToRefetchSubData,
  setPaymentState,
  setUpgradeModalOpen,
} from '../../actions';

import { PaymentState } from '../../types';
import { IState, IUser } from '../../graphql/types';
import { AccountStatus } from '../../enums';
import { UpgradeState } from './Plans';
import { Button, ConfigProvider } from 'antd';

export const PlanButton = ({ plan, setSelectedPlan, setUpgradeState }) => {
  const dispatch = useDispatch();
  const Paddle = window['Paddle'];
  const user = useSelector<IState, IUser | undefined>(state => state.user);

  const handlePayment = useCallback(
    async (planId: string) => {
      await Paddle.Checkout.open({
        product: planId,
        email: user?.email,
        passthrough: {
          userID: user?.userId,
          tenantID: user?.tenantID,
        },
        successCallback: async () => {
          batch(() => {
            dispatch(setPaymentState(PaymentState.processing));
            dispatch(setNeedToRefetchSubData(true));
            dispatch(setUpgradeModalOpen(false));
          });
        },
      });
    },
    [Paddle.Checkout, dispatch, user]
  );

  if (plan.title === 'Business') {
    return (
      <ConfigProvider theme={plan.theme}>
        <Button
          type={'primary'}
          href={`${process.env.REACT_APP_BASE_URL}/contact-us`}
          target="_blank"
          rel="noreferrer"
          className={styles.planButton}
        >
          Let's Talk
        </Button>
      </ConfigProvider>
    );
  }

  const accountStatus = user?.plan.accountStatus;

  const isFreeTrialUser =
    accountStatus === AccountStatus.freeTrialActive ||
    accountStatus === AccountStatus.freeTrialExpired;

  const subscriptionWasCancelled =
    accountStatus === AccountStatus.paddleCanceled ||
    accountStatus === AccountStatus.paddleDeleted;

  const isValidUpgrade =
    (user?.plan.upgradePlans?.includes(+plan.planId) || isFreeTrialUser) &&
    !subscriptionWasCancelled;

  const handleClick = async () => {
    if (user?.plan.accountStatus === AccountStatus.paddleActive) {
      setUpgradeState(UpgradeState.awaitingConfirmation);
      setSelectedPlan(plan);
    } else {
      await handlePayment(plan.planId!);
    }
  };

  return isValidUpgrade ? (
    <ConfigProvider theme={plan.theme}>
      <Button
        type={'primary'}
        onClick={handleClick}
        className={styles.planButton}
      >
        {isFreeTrialUser ? 'Select' : 'Upgrade'}
      </Button>
    </ConfigProvider>
  ) : null;
};
